import { render, staticRenderFns } from "./ErrorGradient.vue?vue&type=template&id=4e1ebf66&"
import script from "./ErrorGradient.vue?vue&type=script&lang=ts&"
export * from "./ErrorGradient.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports